import { SVGInterface } from "../../interface";

const ReceivedTracker = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_441_61915)">
      <path
        d="M5.34993 1.58398C4.47673 1.58398 3.7666 2.29411 3.7666 3.16732V15.834C3.7666 16.7072 4.47673 17.4173 5.34993 17.4173H10.6411C10.4068 16.9249 10.2433 16.3937 10.1633 15.834H5.34993V3.16732H10.8916V7.12565H14.8499V9.5625C15.1088 9.52529 15.3724 9.4991 15.6416 9.4991C15.9108 9.4991 16.1744 9.52529 16.4333 9.5625V6.33398L11.6833 1.58398H5.34993ZM15.6416 11.084C13.4558 11.084 11.6833 12.8565 11.6833 15.0423C11.6833 17.2281 13.4558 19.0007 15.6416 19.0007C17.8274 19.0007 19.5999 17.2281 19.5999 15.0423C19.5999 12.8565 17.8274 11.084 15.6416 11.084ZM17.2651 13.1822L18.3722 14.2909L15.2458 17.4173L12.911 15.0825L14.0181 13.9739L15.2458 15.2L17.2651 13.1822Z"
        fill={color || "black"}
      />
    </g>
    <defs>
      <clipPath id="clip0_441_61915">
        <rect
          width="19"
          height="19"
          fill="white"
          transform="translate(0.599609)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ReceivedTracker;
